interface Props {
  src: string;
  alt: string;
  className?: string;
  eager?: boolean;
  reveal?: 'right' | 'down';
  revealGroup?: string;
  revealVariant?: 'wide' | 'portrait';
  position?: string;
}

export default function Photo({
  src, alt, className = '', eager = false, reveal, revealGroup, revealVariant, position = 'object-top',
}: Props) {
  return (
    <div
      className={`group overflow-hidden bg-background-200 ${className}`}
      data-dw-reveal={reveal}
      data-dw-reveal-group={revealGroup}
      data-dw-reveal-variant={revealVariant}
    >
      <img
        src={src}
        alt={alt}
        title={alt}
        loading={eager ? 'eager' : 'lazy'}
        fetchPriority={eager ? 'high' : 'auto'}
        decoding={eager ? 'auto' : 'async'}
        className={`w-full h-full object-cover ${position} transition-transform duration-700 group-hover:scale-[1.03]`}
      />
    </div>
  );
}